import {autoImplement} from '@/util';
import {Moment} from 'moment';
import moment from 'moment/moment';
import {ApiUmbuchungPosition} from '@/model/UmbuchungPosition';
import {ApiPosition} from '@/model/Position';
import {FulltextSearch} from '@/api/meta/filters';

export interface DetailUmbuchungFilters {
  BelegNr?: number;
}

export interface UmbuchungFilters {
  Erledigt?: boolean;
  Fulltext$Fulltext: FulltextSearch;
}

export interface ApiUmbuchung {
  BelegNr: number;
  Datum: string;
  Bediener: string;
  Erledigt: boolean;
  Positionen?: ApiUmbuchungPosition[];
  NiederlassungEingehend: [{
    Niederlassung: number;
    Bezeichnung: string;
    Name1: string;
  }]
  NiederlassungAbgehend: [{
    Niederlassung: number;
    Bezeichnung: string;
    Name1: string;
  }]
  LKW: [{
    FahrzeugNr: number;
    KFZKennzeichen: string;
    Bezeichnung: string;
  }]
}

export default class Umbuchung extends autoImplement<ApiUmbuchung>() {
  DatumParsed: Moment = moment();

  static fromApi(apiUmbuchung: ApiUmbuchung): Umbuchung {
    const umbuchung = new Umbuchung({
      ...apiUmbuchung,
    });

    umbuchung.DatumParsed = moment(apiUmbuchung.Datum);
    return umbuchung;
  }

  get statusColor() {
    return this.Erledigt ? 'error' : 'success';
  }

  get date() {
    return this.DatumParsed.format('DD.MM.YYYY');
  }

  get DatumFormatted() {
    return moment(this.Datum).format('DD.MM.YYYY');
  }

  get convertedPositions(): ApiPosition[] {
    const originalPositions = this.Positionen ?? [];
    return originalPositions.map((position): ApiPosition => {
      return {
        Posnr: position.PosNr,
        Artikelnr: position.ArtikelNr,
        ArtikelArt: '',
        Bezeichn1: position.ArtikelBezeichnung1,
        Bezeichn2: position.ArtikelBezeichnung2,

        Menge: position.Menge,
        Einheit: 'Stk',
        Eancode: position.EanCode,

        Gebindemenge: 0,
        Gebindeinh: 'Gebinde',
        Gebinhalt: null,
        GebindeSchluessel: 0,
        // eslint-disable-next-line camelcase
        EAN_Gebinde: null,

        Palettenmenge: null,
        Palettennr: null,
        Umrpalgebinde: null,
        Umrpalmenge: 0,

        NVE: position.NVE,

        Chargenpflicht: position.Chargenpflicht ? 'J' : 'N',
        Seriennrpflicht: position.SerienNrpflicht ? 'J' : 'N',

        Matchcode: position.ArtikelGruppe,
        GruppenBezeichnung: position.GruppeBezeichnung,

        // Auftrag
        Belegnr: this.BelegNr,
        Datum: this.date,
        Name: '',

        Buchungen: [{
          Belegnr: position.BelegNr,
          Posnr: position.PosNr,
          Menge: position.Menge,
          Gebindemenge: 0,
          AbgehendesLager: position.AbgehendesLager,
          EingehendesLager: position.EingehendesLager,
          NVE: position.NVE,
        }],
        VerfuegbareNVEs: [],
        Chargen: position.VerfuegbareChargen,
        Restmenge: position.Menge,
        Bediener: this.Bediener,
      };
    });
  }
}

